import { Search } from 'lucide-react';

const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const YEARS = [2023, 2024, 2025, 2026];

/**
 * Edit individual payment record modal — extracted from Budgets.js.
 */
const EditPaymentModal = ({
  open, record, onClose, editForm, setEditForm,
  editEmployeeSearch, setEditEmployeeSearch,
  editFilteredEmployees, onSubmit,
}) => {
  if (!open || !record) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
        <h2 className="text-2xl font-bold text-white mb-6">Editar Pagamento</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Funcionário</label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input
                type="text"
                value={editEmployeeSearch}
                onChange={e => { setEditEmployeeSearch(e.target.value); setEditForm({ ...editForm, employee_email: '' }); }}
                placeholder="Buscar por nome ou email..."
                className="w-full bg-slate-700 border border-slate-600 rounded-lg pl-9 pr-4 py-2 text-white text-sm focus:outline-none focus:border-teal-500"
                data-testid="edit-employee-search"
              />
            </div>
            <div className="mt-1 max-h-28 overflow-y-auto bg-slate-700 border border-slate-600 rounded-lg">
              {editFilteredEmployees.map(u => (
                <button
                  key={u.id}
                  type="button"
                  onClick={() => { setEditForm({ ...editForm, employee_email: u.email }); setEditEmployeeSearch(u.artist_name || u.name); }}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-600 transition-colors flex items-center gap-2 ${editForm.employee_email === u.email ? 'text-teal-400 bg-teal-500/10' : 'text-white'}`}
                >
                  <span className="truncate">{u.artist_name || u.name}</span>
                </button>
              ))}
            </div>
            {editForm.employee_email && <p className="mt-1 text-xs text-teal-400">Novo: {editForm.employee_email}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Nome do Vídeo/Projeto</label>
            <input type="text" value={editForm.video_name} onChange={e => setEditForm({ ...editForm, video_name: e.target.value })}
              className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500" data-testid="edit-video-name" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Valor (R$)</label>
            <input type="number" step="0.01" min="0" value={editForm.value} onChange={e => setEditForm({ ...editForm, value: e.target.value })}
              className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500" data-testid="edit-value" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Mês</label>
              <select value={editForm.month} onChange={e => setEditForm({ ...editForm, month: parseInt(e.target.value) })}
                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500" data-testid="edit-month">
                {MONTHS.map((month, idx) => <option key={idx} value={idx + 1}>{month}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Ano</label>
              <select value={editForm.year} onChange={e => setEditForm({ ...editForm, year: parseInt(e.target.value) })}
                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500" data-testid="edit-year">
                {YEARS.map(year => <option key={year} value={year}>{year}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-3 pt-4">
            <button type="button" onClick={onClose}
              className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors">Cancelar</button>
            <button type="submit" className="flex-1 bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg transition-colors" data-testid="submit-edit-btn">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPaymentModal;
